export const setToken = (token) => {
  localStorage.setItem("accessToken", token);
};

export const getToken = () => {
  return localStorage.getItem("accessToken") || null;
};

export const setUser = (user) => {
  localStorage.setItem("user", user);
};

export const getUser = () => {
  return localStorage.getItem("user") || null;
};

export const get = (key) => {
  return localStorage.getItem(key) || null;
};

export const set = (key, value) => {
  localStorage.setItem(key, value);
};

export const remove = (key) => {
  localStorage.removeItem(key);
};

export const clear = () => {
  localStorage.clear();
};
